import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PageHeader } from "@excoleadershipui/pionweblib";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// material ui 
import { Stack, Box } from '@mui/material'
// components
import Layout from '../../../../layout/Layout'
import { MuiDataGrid, GridCellExpand } from "../../../../components";

// redux 
import { getRolesChr, rowSelect } from '../../../../features/iam_chr/role_management/rolesSlice';

// --------------------------------------------------------------------------------
const AccessPermissions = (props) => {
  const location = useLocation()
  const dispatch = useDispatch();
  const { rolesData } = useSelector(
    (state) => ({ ...state.rolesChr })
  );
  let Navigate = useNavigate()

  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }

  const data = {
    rows: rolesData?.length > 0 ? rolesData : [],
    columns: [
      { field: "roleCode", headerName: "Role Code", width: 100 },
      {
        field: "roleName",
        headerName: "Role Name",
        width: 250,
        renderCell: renderCellExpand
      },
      {
        field: "roleDescription",
        headerName: "Role Description",
        width: 600,
        renderCell: renderCellExpand
      },
    ],
  };

  useEffect(() => {
    dispatch(getRolesChr());
  }, []);



  return (
    <>

      <Stack flexDirection="row" justifyContent="space-between">
        <Box sx={{ width: "100%" }}>
          <PageHeader variant="pageHeader">Roles</PageHeader>
        </Box>

      </Stack>
      <MuiDataGrid

        toolbarFilter={true}

        data={data}
        select={(data) => {
          console.log(data)
          dispatch(rowSelect(data))
          Navigate("/exco/iam/menu-access-permissions-chr", { state: { l3Menu: location?.state?.l3Menu, permissions: location?.state?.permissions, roleName: data[0]?.roleName } })
        }}
      />
    </>
  )
}

export default AccessPermissions